var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinnerLoader1818 = function SvgSpinnerLoader1818(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEE0E1",
    strokeWidth: 2.319,
    d: "M11.504 2.504a6.958 6.958 0 1 1-5.01 12.983 6.958 6.958 0 0 1 5.01-12.983Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#949596",
    strokeLinecap: "round",
    strokeWidth: 2.319,
    d: "M11.504 2.513a6.96 6.96 0 0 1 4.443 6.867"
  })));
};
export default SvgSpinnerLoader1818;